import {useCallback} from 'react';
import {useSetRecoilState} from 'recoil';
import {companyTariffRefreshState} from '../stores/company-tariff.store';

export const useRefreshCompanyTariff = () => {
  const setRefresh = useSetRecoilState(companyTariffRefreshState);
  return useCallback(() => setRefresh((value) => value + 1), [setRefresh]);
};
